import { IconButton, Tooltip } from '@mui/material';

export interface IToolbarButtonProps {
    active?: boolean;
    icon?: React.ReactNode;
    tooltip?: { content?: React.ReactNode };
    onMouseDown?: (event: React.MouseEvent) => void;
    className?: string;
}

export const ToolbarButton = ({
    active,
    icon,
    tooltip,
    onMouseDown,
    className,
}: IToolbarButtonProps) => {
    // MUI's Tooltip only adds aria-describedby while open, it doesn't give
    // its child an accessible name, so icon-only buttons need their own
    // aria-label derived from the same text shown in the tooltip.
    const ariaLabel =
        typeof tooltip?.content === 'string' ? tooltip.content : undefined;

    const button = (
        <IconButton
            aria-label={ariaLabel}
            className={`slate-ToolbarButton${active ? ' slate-ToolbarButton-active' : ''}${className ? ` ${className}` : ''}`}
            size="small"
            onMouseDown={onMouseDown}
        >
            {icon}
        </IconButton>
    );

    if (tooltip?.content) {
        return <Tooltip title={tooltip.content}>{button}</Tooltip>;
    }

    return button;
};
